<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Post Schedule</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="list">List Post Schedule</router-link>
                  </li>
                  <li class="breadcrumb-item active">Post Schedule</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- <div>
                <i>Preparing...</i>
              </div>-->
              <form-wizard
                @on-validate="onValidate"
                :title="''"
                :subtitle="''"
                :finishButtonText="'Publish'"
                :start-index.sync="activeIndex"
                color="#70C95A"
              >
                <Skeleton v-if="isLoading" :count="1" />
                <wizard-step
                  slot-scope="props"
                  slot="step"
                  :tab="props.tab"
                  :transition="props.transition"
                  :index="props.index"
                >
                  <div
                    slot="active-step"
                    style="display: flex; justify-content: center; align-items: center"
                  >
                    <lottie
                      v-if="props.index == 0"
                      :options="animationsForm1"
                      :height="65"
                      :width="65"
                    />
                    <lottie
                      v-else-if="props.index == 1"
                      :options="animationsForm2"
                      :height="65"
                      :width="65"
                    />
                    <lottie
                      v-else-if="props.index == 2"
                      :options="animationsForm3"
                      :height="65"
                      :width="65"
                    />
                  </div>
                </wizard-step>
                <tab-content
                  :before-change="validationForm1"
                  title="Accounts"
                  icon="fa fa-list-alt"
                >
                  <form1 :activeIndex="activeIndex" />
                  <!-- ini tab product -->
                </tab-content>

                <tab-content :before-change="validationForm2" title="Content" icon="fa fa-list-alt">
                  <form2 :activeIndex="activeIndex" />
                </tab-content>
                <tab-content title="Preview" icon="fa fa-list-alt">
                  <form3 :activeIndex="activeIndex" />
                </tab-content>

                <template slot="footer" slot-scope="props">
                  <div class="wizard-footer-left">
                    <wizard-button
                      v-if="props.activeTabIndex > 0"
                      @click.native="props.prevTab()"
                      :style="props.fillButtonStyle"
                    >Previous</wizard-button>
                    <wizard-button
                      v-if="props.isLastStep"
                      @click.native="onComplete(0)"
                      class="btn btn-primary"
                      :style="props.fillButtonStyle"
                    >Draft</wizard-button>
                  </div>
                  <div class="wizard-footer-right">
                    <wizard-button
                      v-if="!props.isLastStep"
                      @click.native="props.nextTab()"
                      class="wizard-footer-right"
                      :style="props.fillButtonStyle"
                    >Next</wizard-button>

                    <template v-else>
                      <span v-if="!isMobile()" style="margin-top:20px;margin-right:60%;">
                        <center>
                          <wizard-button
                            @click.native="onComplete(1)"
                            class="wizard-footer-right finish-button"
                            :style="props.fillButtonStyle"
                          >{{props.isLastStep ? 'Publish' : 'Next'}}</wizard-button>
                        </center>
                      </span>
                      <div v-else style="margin-top:20px;margin-right:60%;">
                        <center>
                          <wizard-button
                            @click.native="onComplete(1)"
                            class="wizard-footer-right finish-button"
                            :style="props.fillButtonStyle"
                          >{{props.isLastStep ? 'Publish' : 'Next'}}</wizard-button>
                        </center>
                      </div>
                    </template>
                  </div>
                </template>
              </form-wizard>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

import Lottie from "vue-lottie";
import animationReview from "@/assets/lottie/review.json";
import animationSchedule from "@/assets/lottie/schedule.json";
import animationStore from "@/assets/lottie/store.json";
import animationFilter from "@/assets/lottie/filter.json";
import animationLoadProduct from "@/assets/lottie/loadProduct.json";
import animationProcessing from "@/assets/lottie/processing.json";
import animationData from "@/assets/animation.js";
import animationData2 from "@/assets/animation2.js";
import rainbow from "@/assets/lottie/rainbow.json";
import {
  FormWizard,
  TabContent,
  WizardStep,
  WizardButton
} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Form1 from "./components/form1.vue";
import Form2 from "./components/form2.vue";
import Form3 from "./components/form3.vue";

export default {
  components: {
    Form1,
    Form2,
    Form3,
    Lottie,
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    FormWizard,
    TabContent,
    WizardStep,
    WizardButton
  },
  data() {
    return {
      isLoading: false,
      activeIndex: 0,
      animationsForm1: { animationData: animationLoadProduct, loop: true },
      animationsForm2: { animationData: animationStore, loop: true },
      animationsForm3: { animationData: animationReview, loop: true },
      // animationsForm4: { animationData: animationSchedule, loop: true },
      // animationsForm5: { animationData: animationReview, loop: true },
      // animationsForm6: { animationData: animationProcessing, loop: true },
      // defaultOptions: { animationData: animationData, loop: false },
      // defaultOptions2: { animationData: rainbow, loop: false },
      animationSpeed: 1
    };
    //  isactive : true
  },
  computed: {
    formParamScrapeSt() {
      return this.$store.state.instagramSchedule.formParamScrapeSt;
    }
    // isShowForm() {
    //   return this.$store.state.monitoring.isShowForm;
    // }
  },
  watch: {},
  created() {
    let id = this.$route.query.id;
    if (typeof id != "undefined" && id != "") {
      // console.log("id", id);
      this.getDetailEditByScheduleId(id);
    }
  },
  methods: {
    getDetailEditByScheduleId(id) {
      this.isLoading = true;
      this.$store
        .dispatch("instagramSchedule/getDetailEditByScheduleId", id)
        .then(response => {
          var { data } = response;
          var that = this;
          setTimeout(function() {
            that.$store.dispatch(
              "instagramSchedule/actFormParamScrapeSt",
              data
            );
            that.isLoading = false;
          }, 300);
          // console.log("ress", response);
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    async onComplete(isPublish) {
      // console.log("complete button", this.formParamScrapeSt);
      let newParam = this.formParamScrapeSt;
      if (isPublish == 1) {
        newParam.is_publish = 1;
      } else {
        newParam.is_publish = 0;
      }
      let copy = this.$route.query.copy;
      if (typeof copy != "undefined" && copy == "1") {
        newParam.id = "";
      }

      await this.$fire({
        title: "Are you sure you want to continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (r.value == true) {
          this.$store
            .dispatch("instagramSchedule/schedulePreparing", newParam)
            .then(async response => {
              this.$fire({
                title: "Preparing",
                text: response["msg"],
                type: "success",
                timer: 4000
              });
              await this.$router.push({
                path: `/instagram/post/list`,
                query: { schedule_id: response.data.id }
              });
            });
        }
      });

      // await this.$store
      //   .dispatch("instagramSchedule/schedulePreparing", newParam)
      //   .then(async response => {
      //     this.$fire({
      //       title: "Preparing",
      //       text: response["msg"],
      //       type: "success",
      //       timer: 4000
      //     });
      //     await this.$router.push({
      //       path: `/instagram/post/list`,
      //       query: { schedule_id: response.data.id }
      //     });
      //   });
    },
    onValidate: function(validateResult, activeIndex) {
      // console.log("onValidate RUN");
      this.$root.$emit("on-validate", validateResult, activeIndex);

      // alert("Yay. Done!");
    },
    validationForm2() {
      console.log("validation Form 2", this.formParamScrapeSt);
      if (
        this.formParamScrapeSt.assets_url != "" &&
        typeof this.formParamScrapeSt.assets_url != "undefined" &&
        this.formParamScrapeSt.assets_url.length < 1
      ) {
        this.$fire({
          title: "Error Assets",
          text: "File wajib diupload",
          type: "error",
          timer: 2000
        });
        return false;
      }
      return true;
    },
    validationForm1() {
      if (this.formParamScrapeSt.title == "") {
        this.$fire({
          title: "Error Title",
          text: "Title/Judul Post Schedule wajib diisi",
          type: "error",
          timer: 2000
        });
        return false;
      }
      if (this.formParamScrapeSt.brand_id == "") {
        this.$fire({
          title: "Error Brand",
          text: "Brand wajib diisi",
          type: "error",
          timer: 2000
        });
        return false;
      }
      if (this.formParamScrapeSt.instagram_account_id.length < 1) {
        this.$fire({
          title: "Error Accounts",
          text: "Account wajib diisi",
          type: "error",
          timer: 2000
        });
        return false;
      }
      if (this.formParamScrapeSt.media_type == "") {
        this.$fire({
          title: "Error Media Type",
          text: "Media Type wajib diisi",
          type: "error",
          timer: 2000
        });
        return false;
      }
      return true;
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "form-scrape"
};
</script>


// WEBPACK FOOTER //
// src/views/instagram/instagramSchedule/wizard.vue